// /settings/mail — «Почта» (005, T033; 008, T014): домены установки и внешняя почта без
// подтверждения (settings.write), блок «Отправка писем» (mail.read). Раздел виден с любым из двух
// прав; остальным — «Нет доступа» с кодом сервера.
import { createFileRoute } from '@tanstack/react-router';
import { MailSettingsPage } from '../../../features/settings/MailSettingsPage.tsx';
import { requireSection } from '../../../shell/permissions.ts';

export const Route = createFileRoute('/_app/_settings/settings/mail')({
  beforeLoad: requireSection('mail'),
  staticData: { crumb: 'Почта' },
  component: MailSettingsPage,
});
